import { supabase } from "@/integrations/supabase/client";

export type PlatformAuditAction = 
  | 'APPROVE_COMPANY' 
  | 'SUSPEND_COMPANY' 
  | 'REACTIVATE_COMPANY'
  | 'BAN_COMPANY'
  | 'VIEW_COMPANY_DETAILS'
  | 'UPDATE_PLATFORM_CONFIG'
  | 'ADD_PLATFORM_ADMIN'
  | 'REMOVE_PLATFORM_ADMIN'
  | 'VIEW_AUDIT_LOGS'
  | 'EXPORT_DATA';

interface LogPlatformActionParams {
  action: PlatformAuditAction;
  targetEntityType: 'company' | 'user' | 'config';
  targetEntityId?: string;
  targetCompanyId?: string;
  description: string;
  details?: Record<string, any>;
}

export const platformAuditService = {
  logAction: async (params: LogPlatformActionParams): Promise<boolean> => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        console.error('Platform Audit: No authenticated user');
        return false;
      }

      const { error } = await supabase
        .from('platform_audit_logs')
        .insert({
          admin_user_id: user.id,
          action_type: params.action,
          target_entity_type: params.targetEntityType,
          target_entity_id: params.targetEntityId || null,
          target_company_id: params.targetCompanyId || null,
          description: params.description,
          details: params.details || null,
          user_agent: navigator.userAgent,
        });

      if (error) {
        console.error('Platform Audit: Error logging action:', error);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Platform Audit: Unexpected error:', error);
      return false;
    }
  },
};
